import NoDataRow from '@/platform/common/components/NoDataRow/NoDataRow';
import { localDate } from '@/platform/lib/utils';
import {
    Button,
    Modal,
    ModalActions,
    ModalContent,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from '@/platform/ui';

const EntitiesModal = ({ invitee, onClose }) => (
    <Modal open={true} onClose={onClose}>
        <ModalContent>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell>Nr.</TableHeaderCell>
                        <TableHeaderCell>Loonheffingennummer</TableHeaderCell>
                        <TableHeaderCell>KvK nummer</TableHeaderCell>
                        <TableHeaderCell>Naam</TableHeaderCell>
                        <TableHeaderCell textAlign='right'>
                            Laatst gesynchroniseerd op
                        </TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {invitee?.entities?.length == 0 && (
                        <NoDataRow numberOfColumns={5} />
                    )}

                    {invitee?.entities?.map(entity => (
                        <TableRow key={entity.id}>
                            <TableCell>{entity.number}</TableCell>
                            <TableCell>{entity.loonheffingennummer}</TableCell>
                            <TableCell>{entity.kvk}</TableCell>
                            <TableCell>{entity.name}</TableCell>
                            <TableCell textAlign='right'>
                                {localDate(entity.last_datahub_sync)}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </ModalContent>
        <ModalActions>
            <Button onClick={onClose}>Sluiten</Button>
        </ModalActions>
    </Modal>
);

export default EntitiesModal;
